
<body>

  <jhi-navbar></jhi-navbar>
  <div>
    <router-outlet></router-outlet>
  </div>

  <jhi-footer></jhi-footer>
  <section class="cookiebar fade" aria-label="Gestione dei cookies">
    <p>Questo sito utilizza solo cookie tecnici. Chiudendo il banner, l'utente accetta l'utilizzo di tutti i cookie.</p>
    <div class="cookiebar-buttons">
      <button data-bs-accept="cookiebar" class="cookiebar-btn cookiebar-confirm">Accetto<span class="visually-hidden"> i cookies</span></button>
    </div>
  </section>
</body>






